import React from 'react';
// import { Spin } from 'antd';
// import CommonMasterFilters from '../../../../components/CommonMasterFilters/CommonMasterFilters';
import * as styles from './overview.module.scss';
// import { OVERVIEW_TABS, TA_DETAIL_PATH, TA_TABS } from '../../talent-analytics.constant';
// import { useHistory } from 'react-router-dom';
import PowerBIEmbed from '../../../Dashboard/PowerBIDashboard';

const Overview = () => {
  // const history = useHistory();
  // const [currentTab, setCurrentTab] = useState(OVERVIEW_TABS[0]);
  // const [filterMasterData, setFilterMasterData] = useState({});
  // const [loading] = useState(false);

  // const searchParams = new URLSearchParams(location.search);
  // const tabIndex = searchParams.get('tab');
  // useEffect(() => {
  //   if (tabIndex && !isNaN(tabIndex)) {
  //     setCurrentTab(OVERVIEW_TABS[tabIndex]);
  //   }
  // }, [tabIndex]);

  // const onChangeTab = (tab, tabNumber) => {
  //   setCurrentTab(tab);
  //   history.push(`${TA_DETAIL_PATH}/${TA_TABS[0].path}?tab=${tabNumber}`);
  // };

  return (
    <div className={styles.wrapper}>
      <PowerBIEmbed />
      {/* <Spin spinning={loading}>
        <CommonMasterFilters setFilterFinderData={setFilterMasterData} filterFinderData={filterMasterData} />
        <div className={styles.contents}>
          <div className={styles.tabs}>
            {OVERVIEW_TABS.map((tab, tabIndex) => (
              <div key={tab} className={`${styles.tab} ${currentTab === tab ? styles.active : ''}`} onClick={() => onChangeTab(tab, tabIndex)}>
                {tab}
              </div>
            ))}
          </div>
        </div>
      </Spin> */}
    </div>
  );
};

export default Overview;
